import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInfosysComponent } from './simple-icons-infosys.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInfosysComponent ],
    exports:      [ SimpleIconsInfosysComponent ],
    bootstrap:    []
})
export class SimpleIconsInfosysModule {}
